import React from 'react';
import { Card, CardContent } from './ui/card';
import { ExternalLink } from 'lucide-react';

/**
 * Bloque de prensa / Apariciones en medios.
 * Reutilizable en /agregar-centro, /unirse-profesional, /registrar-taller.
 * Sin Card duplicada en 3 archivos = no más drift entre páginas.
 */

const MEDIA = [
  {
    id: 'lahora',
    outlet: 'La Hora',
    date: '2026',
    titulo: '"De la adicción al directorio más consultado de Chile: la historia de dos profesionales que salieron del infierno"',
    bajada: 'La historia detrás de SinAdicciones.org y cómo dos profesionales convirtieron su experiencia de recuperación en la plataforma de adicciones más consultada del país.',
    image: '/images/press/lahora-reportaje.png',
    bgClass: 'bg-slate-900',
    imgClass: 'w-full h-full object-cover',
    href: 'https://lahora.cl/cronica/2026/04/10/de-la-adiccion-al-directorio-mas-consultado-de-chile-la-historia-de-dos-profesionales-que-salieron-del-infierno/',
    linkClass: 'text-blue-400 hover:text-blue-300',
  },
  {
    id: 'usach',
    outlet: 'Diario USACH',
    date: '2026',
    titulo: '"Crean sitio web con información sobre centros de rehabilitación, profesionales y talleres terapéuticos en Chile"',
    bajada: 'La plataforma SinAdicciones.org cuenta con más de 200 centros en las 16 regiones del país, con precios reales, metodologías explicadas y un comparador que permite evaluar opciones según región, modalidad y costo.',
    image: 'https://customer-assets.emergentagent.com/job_b3e01f14-9bf6-43e2-8803-5135c9820171/artifacts/d5oqarth_image.png',
    bgClass: 'bg-slate-100',
    imgClass: 'w-full h-full object-cover object-top',
    href: 'https://www.diariousach.cl/crean-sitio-web-con-informacion-sobre-centros-de-rehabilitacion',
    linkClass: 'text-orange-400 hover:text-orange-300',
  },
  {
    id: 'elciudadano',
    outlet: 'El Ciudadano',
    date: '18/05/2026',
    titulo: '"La droga que el Estado no sabe tratar"',
    bajada: 'Columna publicada en El Ciudadano. Chile incauta cuatro veces más Tussi y no tiene protocolo clínico. El Estado persigue la droga; no trata a quienes la consumen.',
    image: 'https://customer-assets.emergentagent.com/job_b3e01f14-9bf6-43e2-8803-5135c9820171/artifacts/y3wuxps4_image.png',
    bgClass: 'bg-white',
    imgClass: 'w-full h-full object-cover object-top',
    href: 'https://www.elciudadano.com/columnas/la-droga-que-el-estado-no-sabe-tratar/05/18/',
    linkClass: 'text-rose-400 hover:text-rose-300',
  },
];

export default function MediaCoverage() {
  return (
    <div className="space-y-6" data-testid="media-coverage">
      {MEDIA.map((m) => (
        <Card
          key={m.id}
          className="bg-slate-900 border-slate-800 overflow-hidden"
          data-testid={`media-card-${m.id}`}
        >
          <div className="grid md:grid-cols-2 gap-0">
            <div className={`relative h-64 md:h-auto ${m.bgClass} flex items-center justify-center overflow-hidden`}>
              <img
                src={m.image}
                alt={m.outlet}
                className={m.imgClass}
                loading="lazy"
                onError={function (e) { e.target.style.display = 'none'; }}
              />
            </div>
            <CardContent className="p-8 flex flex-col justify-center">
              <div className="flex items-center gap-2 mb-4">
                <span className="text-slate-500 text-sm">{m.outlet} · {m.date}</span>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-slate-50 mb-4 leading-tight">
                {m.titulo}
              </h3>
              <p className="text-slate-400 mb-6">{m.bajada}</p>
              <a
                href={m.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`inline-flex items-center gap-2 ${m.linkClass} font-medium transition-colors`}
                data-testid={`media-link-${m.id}`}
              >
                Leer reportaje completo
                <ExternalLink className="w-4 h-4" />
              </a>
            </CardContent>
          </div>
        </Card>
      ))}
    </div>
  );
}
